<template>
  <div>
    <div class="credit ws-textbox">
      <h2 class="title-choose-photo" style="margin-bottom: 0px">
        {{ lang['refreshment_photo_claim_new'].SFS_LANG_ROW_2 }}
      </h2>
      <h2 class="title-choose-photo" style="margin-bottom: 0px">{{ refreshmentPriceCurrency }} {{ formatPrice(totalAmount) }}</h2>
    </div>
    <div class="photo2claim-help ws-textbox" :style="{ float: direction == 'rtl' ? 'right' : 'left' }">
      <h2 class="title-choose-photo">
        {{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_3'] }}
      </h2>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(1, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_8'] }}</span>
        </p>
      </div>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(2, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_9'] }}</span>
        </p>
      </div>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(3, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_10'] }}</span>
        </p>
      </div>
      <div class="photo2claim-clear">
        <p class="icon-photo2claim-helper how-does-it-work-icon-color">
          <span>
            <i :class="iConClass(4, lang)"></i>
          </span>
          <span class="icon-title">{{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_11'] }}</span>
        </p>
      </div>
    </div>
    <div style="clear: both"></div>
    <!-- step 1 -->
    <div class="step-photo ws-textbox">
      <h2 class="title-choose-photo">
        {{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_12'] }}
      </h2>
      <div v-if="listPaxReceipt.length > 0">
        <p class="mb-2">{{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_13'] }}</p>
        <div class="list-receipt">
          <div v-for="(item, k) in listPaxReceipt" :key="k" class="item-receipt mb-3">
            <div v-if="!item.remake">
              <div class="img-item-receipt">
                <div v-if="isPdf(item.image_url)" class="pdf-container">
                  <embed class="pdf-object" :src="item.image_url" type="application/pdf" />
                </div>
                <img v-else :src="item.image_url" alt="" />
              </div>
              <div class="pt-3 receipt-amount">
                <p>{{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_14'] }}: {{ item.currency }} {{ item.amount }}</p>
              </div>
              <div class="btn-handle-receipt btn-handle">
                <p class="btn-handle-check" :class="listPaxReceipt.length > 0 ? 'mr-2' : ''" @click="removePicture(k)">
                  {{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_16'] }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="!listPaxReceipt">
            <div class="mb-2">
              <div class="btn-take-photo">
                <button id="photoPayStepFileUploadButton" class="receipt-plus" @click="handleClickFileUpload('receipt')">
                  <i class="fas fa-plus"></i> {{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_17'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="mb-2">
          <div class="btn-take-photo">
            <button
              v-if="uploadReceipt || listPaxReceipt.length == 0"
              id="photoPayStepFileUploadButton2"
              :aria-label="lang.refreshment_photo_claim_new['SFS_LANG_ROW_17']"
              @click="handleClickFileUpload('receipt')"
            >
              <i class="fas fa-camera"></i>
            </button>
            <button
              v-else
              id="photoPayStepFileUploadButton2"
              class="ws-btn add-receipt2"
              :aria-label="lang.refreshment_photo_claim_new['SFS_LANG_ROW_17']"
              @click="handleClickFileUpload('receipt')"
            >
              <i class="fas fa-plus"></i> {{ lang.refreshment_photo_claim_new['SFS_LANG_ROW_17'] }}
            </button>
          </div>
        </div>
      </div>
      <input
        id="file-receipt"
        ref="receipt"
        type="file"
        accept="image/*;capture=camera"
        style="display: none"
        aria-label="File Upload"
        @change="handleFileUpload($event, 'receipt')"
      />
    </div>
    <!-- step 2 -->
    <div v-if="showBankDetail" style="margin-bottom: 10px">
      <NewTransferWiseForm
        id="photoPayStepTransferWise"
        :wise-bank-detail="RefreshmentInfo.bank_info"
        :lang-transfer-wise="lang.refreshment_photo_claim_new"
        :is-name-null="isNameNull"
        @updateInfoPaxBank="updateInfoPaxBank"
        @updateIsNameNull="updateIsNameNull"
      />
    </div>
    <div v-if="pax.enable_ref_print_a4 == 1" class="step-photo">
      <p
        style="padding: 0.5rem 0"
        v-html="replaceStr(lang.refreshment_photo_claim_new['SFS_LANG_ROW_18'], ['<airline>'], [airline.name])"
      ></p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import vueCountryRegionSelect from 'vue-country-region-select'
import { replaceStr, isPdf } from '@/utils/helper'
import { mapGetters } from 'vuex'
import NewTransferWiseForm from '@/components/NewTransferWiseForm/Index'
import { NOT_VALID } from '@/constants/wise-error-code'
import { HTTP_UNPROCESSABLE_ENTITY } from '@/constants/http-status-codes'

Vue.use(vueCountryRegionSelect)
export default {
  components: {
    NewTransferWiseForm
  },
  props: {
    secret: {
      type: String,
      default: ''
    },
    RefreshmentInfo: {
      type: Object,
      default: () => {}
    },
    RefreshmentPrice: {
      type: Array,
      default: () => []
    },
    isNameNull: Boolean
  },
  data() {
    return {
      file: '',
      idx: 0,
      enableSingleUse: 0,
      uploadReceipt: true,
      listPaxReceipt: [],
      listRemake: [],
      infoPaxBank: {},
      keyReceipt: null,
      refreshmentService: {},
      refreshmentDetail: {},
      notifyValidSwift: false,
      totalAmount: 0,
      validateInfoBank: {},
      showPopupPrinted: false,
      currencyReceipt: '',
      showBankDetail: false
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services'
    }),
    refreshmentPriceCurrency() {
      // @TODO
      // trong trường hợp các pax khác voucher code -> không lấy được voucher refreshment của pax còn lại -> RefreshmentPrice[0].currency sẽ không lấy được currency
      // fix tạm thế này để hiển thị currency, sau khi chốt business combine 2 (hoặc nhiều) refreshment voucher khác voucher code, khác currency -> sẽ update lại sau
      return _.find(this.RefreshmentPrice, 'currency')?.currency || ''
    }
  },
  watch: {
    Services: {
      handler() {
        this.initData()
      },
      deep: true
    },
    RefreshmentInfo(val) {
      this.initData()
    },
    RefreshmentPrice: {
      handler() {
        this.totalAmount = _.sumBy(this.RefreshmentPrice, function (o) {
          return parseFloat(o.price_per_person)
        })
      },
      deep: true
    }
  },
  mounted() {
    if (_.find(this.Services, { service_id: 1 })) {
      this.initData()
    } else {
      this.$store.dispatch('Home/getServices')
      this.initData()
    }
  },
  methods: {
    replaceStr,
    isPdf,
    initData() {
      let self = this
      if (self.showPopupPrinted) {
        return
      }
      self.refreshmentService = _.find(self.Services, { service_id: 2 })
      self.refreshmentDetail = _.find(self.refreshmentService.list_refreshment, { id: parseInt(this.$route.query.refreshmentId) })
      if (self.refreshmentDetail && self.refreshmentDetail.is_printed && !self.showPopupPrinted) {
        self
          .$swal({
            title: self.lang.refreshment_photo_claim_new['SFS_LANG_ROW_19']
          })
          .then(() => {
            self.$router.push({ path: '/home', query: { secret: self.secret } })
          })
        self.showPopupPrinted = true
        return
      }
      if (self.RefreshmentInfo && self.RefreshmentInfo.bank_info) {
        if (self.RefreshmentInfo.list_receipt && self.RefreshmentInfo.list_receipt.length > 0) {
          self.listPaxReceipt = self.RefreshmentInfo.list_receipt
          self.currencyReceipt = self.listPaxReceipt[0]['currency']
          self.showBankDetail = self.listPaxReceipt.length > 0 ? true : false
          self.uploadReceipt = false
        }
      }
      if (!_.isEmpty(self.airline.params)) {
        self.enableSingleUse = self.airline.params.photo2claim.enable_single_use
      }
      if (self.RefreshmentPrice) {
        self.totalAmount = _.sumBy(self.RefreshmentPrice, function (o) {
          return parseFloat(o.price_per_person)
        })
      }
    },
    checkSwift(e) {
      let value = e.target.value
      if (value) {
        this.notifyValidSwift = false
      }
    },
    removePicture(key) {
      this.listRemake.push(this.listPaxReceipt[key].image_path)
      _.remove(this.listPaxReceipt, function (n, k) {
        return k == key
      })
      this.currencyReceipt =
        this.listPaxReceipt.length == 0 || this.listPaxReceipt.length == this.listRemake.length ? '' : this.currencyReceipt
      this.showBankDetail = this.listPaxReceipt.length > 0 ? true : false
      this.$forceUpdate()
    },
    handleClickFileUpload(refName) {
      this.$refs[refName].click()
    },
    handleFileUpload: function (event, type) {
      if (event) {
        event.stopPropagation()
      }
      this.file = this.$refs[type].files[0]
      this.submitFile(event, type)
    },

    updateInfoPaxBank(infoPaxBank) {
      this.infoPaxBank = infoPaxBank
      this.saveInfoPax()
    },

    saveInfoPax() {
      let self = this
      let listPaxReceiptRemake = _.cloneDeep(self.listPaxReceipt)
      _.remove(listPaxReceiptRemake, { remake: true })
      if (listPaxReceiptRemake.length == 0) {
        self.$swal(this.lang.refreshment_photo_claim_new['SFS_LANG_ROW_20'])
        return false
      }
      let totalAmount = 0
      _.forEach(self.listPaxReceipt, function (item) {
        item.service_id = 2
        totalAmount += parseFloat(item.amount)
      })
      if (totalAmount == 0) {
        self.$swal(
          this.lang.refreshment_photo_claim_new['SFS_LANG_ROW_36'] ||
            'Unable to upload receipt with value 0, please upload other!'
        )
        return false
      }
      self.infoPaxBank.service_id = 2 // service refreshment
      self.infoPaxBank.amount = totalAmount
      let dataSend = {
        data: {
          list_receipt: self.listPaxReceipt,
          list_remake: self.listRemake,
          info_bank: self.infoPaxBank
        },
        secret: self.secret,
        refreshmentId: this.$route.query.refreshmentId
      }
      this.$store.dispatch('Refreshment/saveInfoPax', dataSend).then((response) => {
        if (response.success === undefined) {
          self.$swal('Action failed')
          return
        }

        if (response.success === true) {
          this.$store.dispatch('Refreshment/getInfoRef', this.$route.query.refreshmentId)
          return
        }

        // EF: Legacy case, currently revolut isn't used but since we have still revolut code all
        //   over the place we keep this in place.
        if (response.revolut_message && response.revolut_message.trim() !== '') {
          self.$swal('Action failed')
          return
        }

        if (response.message?.statusCode === HTTP_UNPROCESSABLE_ENTITY) {
          const error = (response.message?.wsData?.errors || [])[0] || {}
          if (!error.code) {
            self.$swal('Action failed')
          } else if (error.code === NOT_VALID) {
            self.$swal(
              self.lang.refreshment_photo_claim_new['SFS_LANG_TRANSFER_WISE_17'] ||
                'This account is not validated. Please retype your account details'
            )
          } else {
            self.$swal(
              self.lang.refreshment_photo_claim_new['SFS_LANG_TRANSFER_WISE_15'] ||
                'Unfortunately it is not possible to transfer money to this country. Please use another bank account or go to the desk for support.'
            )
          }
          return
        }

        self.$swal(
          typeof response.message === 'string' || response.message instanceof String ? response.message : 'Action failed'
        )
      })
    },
    addReceipt() {
      this.uploadReceipt = true
    },
    submitFile(event, type) {
      if (!this.file) {
        return false
      }

      let max_size = 20
      if (this.airline.params && this.airline.params.klippa && this.airline.params.klippa.maximum_file_size) {
        max_size = this.airline.params.klippa.maximum_file_size
      }
      let self = this
      let fileSize = parseFloat((this.file.size / 1024 / 1024).toFixed(4))
      if (fileSize > max_size) {
        self.$swal(self.replaceStr(self.lang.refreshment_photo_claim_new['SFS_LANG_ROW_21'], '<maximum_file_size>', max_size))
        this.$refs[type].value = null
        return false
      }
      let formData = new FormData()
      formData.set('secret', this.secret)
      formData.append('image', this.file)
      this.uploadReceipt = false
      // Upload file
      self.$store.dispatch('Refreshment/uploadImg', { formData }).then((response) => {
        this.$refs[type].value = null
        if (response.success) {
          let resData = response.data
          if (type == 'receipt') {
            if (!self.checkTImePurchase(resData.purchasedate, resData.purchasetime)) {
              self.$swal(self.lang.refreshment_photo_claim_new['SFS_LANG_ROW_22'])
              this.listRemake.push(resData.image_path)
              return false
            }
            let receiptAdd = {
              image_url: resData.image_url,
              image_path: resData.image_path,
              merchant_name: resData.merchant_name,
              purchase_date: resData.purchasedate,
              purchase_time: resData.purchasetime,
              currency: resData.currency,
              amount: (parseFloat(resData.amount) / 100).toFixed(2),
              amount_include: (parseFloat(resData.vatamount) / 100).toFixed(2),
              params: JSON.stringify(resData)
            }
            if (!_.isEmpty(self.currencyReceipt) && resData.currency != self.currencyReceipt) {
              self.$swal(self.lang.refreshment_photo_claim_new['SFS_LANG_ROW_23'])
              this.listRemake.push(resData.image_path)
              return false
            } else {
              self.currencyReceipt = resData.currency
            }
            let totalAmount = 0
            if (!_.isNull(self.keyReceipt)) {
              let idReceipt = _.cloneDeep(self.listPaxReceipt[self.keyReceipt].id)
              self.listPaxReceipt[self.keyReceipt] = receiptAdd
              _.forEach(self.listPaxReceipt, function (item) {
                totalAmount += parseFloat(item.amount)
              })
              self.listPaxReceipt[self.keyReceipt].id = idReceipt
              self.listPaxReceipt[self.keyReceipt].remake = false
              self.keyReceipt = null
            } else {
              _.forEach(self.listPaxReceipt, function (item) {
                totalAmount += parseFloat(item.amount)
              })
              totalAmount += parseFloat(receiptAdd.amount)
              self.listPaxReceipt.push(receiptAdd)
            }
            self.uploadReceipt = false
          }
          self.showBankDetail = self.listPaxReceipt.length > 0 ? true : false
          self.$forceUpdate()
        } else {
          self.$swal(self.lang.refreshment_photo_claim_new['SFS_LANG_ROW_24'])
        }
      })
    },
    checkTImePurchase(date, time) {
      // Config to skip check validate expiry time
      if (!this.airline.params.photo2claim.validation_check_expiry_time) {
        return true
      }

      let expire_hour = parseInt(this.airline.params.photo2claim.expire_hour || 12)
      let flightTime = this.pax.etd ? this.pax.etd : this.pax.std
      let datePurchase = this.moment(date + 'T' + time)
      let timeEnd = this.moment(flightTime).add(expire_hour, 'hours')

      return datePurchase <= timeEnd
    },
    checkReceipt() {
      let self = this
      let listPaxReceiptRemake = _.cloneDeep(self.listPaxReceipt)
      _.remove(listPaxReceiptRemake, { remake: true })
      if (listPaxReceiptRemake.length == 0 || listPaxReceiptRemake.length !== self.listPaxReceipt.length) {
        self.$swal(this.lang.refreshment_photo_claim_new['SFS_LANG_ROW_20'])
        return false
      }
      return true
    },
    iConClass: function (type, lang) {
      let className = ''
      switch (type) {
        case 1:
          className = lang.refreshment_photo_claim_new['SFS_LANG_ROW_4']
            ? lang.refreshment_photo_claim_new['SFS_LANG_ROW_4']
            : 'fas fa-shopping-basket'
          break
        case 2:
          className = lang.refreshment_photo_claim_new['SFS_LANG_ROW_5']
            ? lang.refreshment_photo_claim_new['SFS_LANG_ROW_5']
            : 'fas fa-camera'
          break
        case 3:
          className = lang.refreshment_photo_claim_new['SFS_LANG_ROW_6']
            ? lang.refreshment_photo_claim_new['SFS_LANG_ROW_6']
            : 'far fa-credit-card'
          break
        case 4:
          className = lang.refreshment_photo_claim_new['SFS_LANG_ROW_7']
            ? lang.refreshment_photo_claim_new['SFS_LANG_ROW_7']
            : 'fas fa-gift'
          break
        default:
      }

      return className + ' fa-2x'
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2)
      return val.toString()
    },
    strReplace(str) {
      let self = this
      let search = ['<currency>', '<amount_total>']
      let rep = [self.refreshmentService.currency, self.formatPrice(self.totalAmount)]
      return self.replaceStr(str, search, rep)
    },
    updateIsNameNull(value) {
      this.$emit('updateIsNameNull', value)
    }
  }
}
</script>
<style scoped>
.pdf-container {
  width: 100%;
  height: 0;
  padding-bottom: 100%; /* Set the aspect ratio to match the page size */
  position: relative;
  overflow: hidden;
}

.pdf-object {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
